import { dataClockSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconClockSolid = /*#__PURE__*/createIcon(dataClockSolid)
export default IconClockSolid
